import createReducer from "../../reducers/createReducer";
import {
  ENG_SEGMENT_LIST_LOADING, ENG_SEGMENT_LIST_SUCCESS, ENG_SEGMENT_LIST_ERROR,
  ENG_SEGMENT_CREATE_LOADING, ENG_SEGMENT_CREATE_SUCCESS, ENG_SEGMENT_CREATE_ERROR,
  ENG_SEGMENT_PREVIEW_LOADING, ENG_SEGMENT_PREVIEW_SUCCESS, ENG_SEGMENT_PREVIEW_ERROR,
  ENG_TEMPLATE_LIST_LOADING, ENG_TEMPLATE_LIST_SUCCESS, ENG_TEMPLATE_LIST_ERROR,
  ENG_CAMPAIGN_LIST_LOADING, ENG_CAMPAIGN_LIST_SUCCESS, ENG_CAMPAIGN_LIST_ERROR,
  ENG_CAMPAIGN_CREATE_LOADING, ENG_CAMPAIGN_CREATE_SUCCESS, ENG_CAMPAIGN_CREATE_ERROR,
  ENG_CAMPAIGN_LAUNCH_LOADING, ENG_CAMPAIGN_LAUNCH_SUCCESS, ENG_CAMPAIGN_LAUNCH_ERROR,
  ENG_CAMPAIGN_PAUSE_LOADING, ENG_CAMPAIGN_PAUSE_SUCCESS, ENG_CAMPAIGN_PAUSE_ERROR,
  ENG_CAMPAIGN_CANCEL_LOADING, ENG_CAMPAIGN_CANCEL_SUCCESS, ENG_CAMPAIGN_CANCEL_ERROR,
  ENG_CAMPAIGN_ANALYTICS_LOADING, ENG_CAMPAIGN_ANALYTICS_SUCCESS, ENG_CAMPAIGN_ANALYTICS_ERROR,
  ENG_RESET_MUTATION,
} from "./types";

const initialState = {
  segments: [],
  segmentsNext: null,
  segmentPreview: null,
  templates: [],
  templatesNext: null,
  campaigns: [],
  campaignsNext: null,
  analytics: null,
  loading: false,
  analyticsLoading: false,
  mutationLoading: false,
  mutationSuccess: false,
  mutationError: null,
  lastMutation: null,
};

const resolveState = (state, patch) => ({ ...state, ...patch });

export const engagementReducer = createReducer(initialState, {
  // Segments
  [ENG_SEGMENT_LIST_LOADING]: (s) => resolveState(s, { loading: true }),
  [ENG_SEGMENT_LIST_SUCCESS]: (s, a) => resolveState(s, {
    loading: false,
    segments: a.payload?.data || [],
    segmentsNext: a.payload?.next || null,
  }),
  [ENG_SEGMENT_LIST_ERROR]: (s) => resolveState(s, { loading: false }),

  [ENG_SEGMENT_CREATE_LOADING]: (s) => resolveState(s, { mutationLoading: true, mutationSuccess: false, mutationError: null, lastMutation: "segment_create" }),
  [ENG_SEGMENT_CREATE_SUCCESS]: (s, a) => resolveState(s, {
    mutationLoading: false,
    mutationSuccess: true,
    lastMutation: "segment_create",
    segments: [a.payload?.data || a.payload, ...s.segments],
  }),
  [ENG_SEGMENT_CREATE_ERROR]: (s, a) => resolveState(s, { mutationLoading: false, mutationError: a.payload, lastMutation: "segment_create" }),

  [ENG_SEGMENT_PREVIEW_LOADING]: (s) => resolveState(s, { loading: true, segmentPreview: null }),
  [ENG_SEGMENT_PREVIEW_SUCCESS]: (s, a) => resolveState(s, { loading: false, segmentPreview: a.payload?.data || a.payload }),
  [ENG_SEGMENT_PREVIEW_ERROR]: (s) => resolveState(s, { loading: false }),

  // Templates
  [ENG_TEMPLATE_LIST_LOADING]: (s) => resolveState(s, { loading: true }),
  [ENG_TEMPLATE_LIST_SUCCESS]: (s, a) => resolveState(s, {
    loading: false,
    templates: a.payload?.data || [],
    templatesNext: a.payload?.next || null,
  }),
  [ENG_TEMPLATE_LIST_ERROR]: (s) => resolveState(s, { loading: false }),

  // Campaigns
  [ENG_CAMPAIGN_LIST_LOADING]: (s) => resolveState(s, { loading: true }),
  [ENG_CAMPAIGN_LIST_SUCCESS]: (s, a) => resolveState(s, {
    loading: false,
    campaigns: a.payload?.data || [],
    campaignsNext: a.payload?.next || null,
  }),
  [ENG_CAMPAIGN_LIST_ERROR]: (s) => resolveState(s, { loading: false }),

  [ENG_CAMPAIGN_CREATE_LOADING]: (s) => resolveState(s, { mutationLoading: true, mutationSuccess: false, mutationError: null, lastMutation: "campaign_create" }),
  [ENG_CAMPAIGN_CREATE_SUCCESS]: (s, a) => {
    const campaign = a.payload?.data || a.payload;
    return resolveState(s, { mutationLoading: false, mutationSuccess: true, lastMutation: "campaign_create", campaigns: [campaign, ...s.campaigns] });
  },
  [ENG_CAMPAIGN_CREATE_ERROR]: (s, a) => resolveState(s, { mutationLoading: false, mutationError: a.payload, lastMutation: "campaign_create" }),

  [ENG_CAMPAIGN_LAUNCH_LOADING]: (s) => resolveState(s, { mutationLoading: true, mutationError: null, mutationSuccess: false, lastMutation: "campaign_launch" }),
  [ENG_CAMPAIGN_LAUNCH_SUCCESS]: (s, a) => {
    const updated = a.payload?.data || a.payload;
    return resolveState(s, { mutationLoading: false, mutationSuccess: true, lastMutation: "campaign_launch", campaigns: s.campaigns.map((c) => c.id === updated.id ? updated : c) });
  },
  [ENG_CAMPAIGN_LAUNCH_ERROR]: (s, a) => resolveState(s, { mutationLoading: false, mutationError: a.payload, lastMutation: "campaign_launch" }),

  [ENG_CAMPAIGN_PAUSE_LOADING]: (s) => resolveState(s, { mutationLoading: true, mutationError: null, mutationSuccess: false, lastMutation: "campaign_pause" }),
  [ENG_CAMPAIGN_PAUSE_SUCCESS]: (s, a) => {
    const updated = a.payload?.data || a.payload;
    return resolveState(s, { mutationLoading: false, mutationSuccess: true, lastMutation: "campaign_pause", campaigns: s.campaigns.map((c) => c.id === updated.id ? updated : c) });
  },
  [ENG_CAMPAIGN_PAUSE_ERROR]: (s, a) => resolveState(s, { mutationLoading: false, mutationError: a.payload, lastMutation: "campaign_pause" }),

  [ENG_CAMPAIGN_CANCEL_LOADING]: (s) => resolveState(s, { mutationLoading: true, mutationError: null, mutationSuccess: false, lastMutation: "campaign_cancel" }),
  [ENG_CAMPAIGN_CANCEL_SUCCESS]: (s, a) => {
    const updated = a.payload?.data || a.payload;
    return resolveState(s, { mutationLoading: false, mutationSuccess: true, lastMutation: "campaign_cancel", campaigns: s.campaigns.map((c) => c.id === updated.id ? updated : c) });
  },
  [ENG_CAMPAIGN_CANCEL_ERROR]: (s, a) => resolveState(s, { mutationLoading: false, mutationError: a.payload, lastMutation: "campaign_cancel" }),

  [ENG_CAMPAIGN_ANALYTICS_LOADING]: (s) => resolveState(s, { analyticsLoading: true }),
  [ENG_CAMPAIGN_ANALYTICS_SUCCESS]: (s, a) => resolveState(s, { analyticsLoading: false, analytics: a.payload?.data || a.payload }),
  [ENG_CAMPAIGN_ANALYTICS_ERROR]: (s, a) => resolveState(s, { analyticsLoading: false, mutationError: a.payload, lastMutation: "campaign_analytics" }),

  [ENG_RESET_MUTATION]: (s) => resolveState(s, { mutationLoading: false, mutationSuccess: false, mutationError: null, lastMutation: null }),
});
